import { Link } from 'react-router-dom';
import { Icon } from '../../components/Icon';
import { RepoList } from '../../components/RepoList';
import { ErrorBox, Loading } from '../../components/Ui';
import { useAsync } from '../../hooks';
import { get, type Repo } from '../../services/api';
import { canWrite } from '../../shared/utils/conversations';
import { useRepo } from './RepoLayout';

export function RepoForks() {
  const { repo, base } = useRepo();
  const result = useAsync(() => get<{ items: Repo[] }>(`/repositories/${repo.id}/forks`), [repo.id]);
  return (
    <section className="stack">
      <header className="section-title">
        <h2>Forks of {repo.name}</h2>
        <p className="muted">
          Independent copies with their own history. Showing up to 50 recent forks you have access to.
        </p>
        {result.data?.items.some((fork) => canWrite(fork.role)) && (
          <p>
            <Link className="btn primary" to={`${base}/proposals/new`}>
              <Icon name="proposal" />
              Propose changes from your fork
            </Link>
          </p>
        )}
      </header>
      {result.loading && !result.data ? (
        <Loading />
      ) : result.error ? (
        <ErrorBox error={result.error} retry={result.reload} />
      ) : (
        <div className="card">
          <RepoList repos={result.data?.items ?? []} empty="No visible forks yet" />
        </div>
      )}
    </section>
  );
}
